// document.querySelectorAll(".js-open-accordion").forEach(function(element) {
//     element.addEventListener("click", function() {
//         const parent = this.parentNode;
//         parent.classList.toggle("open");
//         const siblings = Array.from(parent.parentNode.children).filter(function(child) {
//             return child !== parent;
//         });
//         siblings.forEach(function(sibling) {
//             sibling.classList.remove("open");
//         });
//     });
// });